import React from 'react';
import {style, classes} from './doppe-page-default-image-view.st.css';
import DefaultImage1 from './images/doppe-page-default-image-1.svg';
import DefaultImage2 from './images/doppe-page-default-image-2.svg';
import DefaultImageSquareInner from './images/doppe-page-default-image-square-inner.svg';
import DefaultImageCoverPhotoInverted from './images/doppe-page-default-image-cover-photo-inner.svg';
import {evaluateFunction, Values} from "@wix/devzai-utils-common";

export const DoppePageDefaultImageViewImage = {
    Image1: 'image1',
    SquareImage2: 'squareImage2',
    FullPageImage: 'fullPageImage',
    CoverImage: 'coverImage'
} as const;

export type DoppePageDefaultImageViewImage = Values<typeof DoppePageDefaultImageViewImage>;

export const DoppePageDefaultImageView = React.memo(function DoppePageDefaultImageView (props: DoppePageDefaultImageView.Props) {
    const {
        image,

        className,
        ...htmlAttributes
    } = props;

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {image: image}, className)}
        >
            {evaluateFunction(() => {
                switch (image) {
                    case DoppePageDefaultImageViewImage.Image1: {
                        return (
                            <DefaultImage1
                                className={style(classes.defaultImage, {})}
                            />
                        )
                    }
                    case DoppePageDefaultImageViewImage.SquareImage2: {
                        return (
                            <DefaultImageSquareInner
                                className={style(classes.defaultImage, {})}
                            />
                        )
                    }
                    case DoppePageDefaultImageViewImage.FullPageImage: {
                        return (
                            <DefaultImage2
                                className={style(classes.defaultImage, {})}
                            />
                        )
                    }
                    case DoppePageDefaultImageViewImage.CoverImage: {
                        return (
                            <DefaultImageCoverPhotoInverted
                                className={style(classes.defaultImage, {})}
                            />
                        )
                    }
                }
            })}
        </div>
    );
});

export namespace DoppePageDefaultImageView {
    
    export interface Props extends React.HTMLAttributes<any> {
        image: DoppePageDefaultImageViewImage;
    }
}
